import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

import globalTranslations from '../../../../i18n/globalTranslations';
import { modelOf } from '../../../../prop-types';
import CartStore from '../../../../store/CartStore';
import ConfigStore from '../../../../store/ConfigStore';
import RequestState from '../../../../types/RequestState';
import SiteType from '../../../../types/Site';
import Icon from '../../../common/Icon';
import MarkerBadge from '../../../common/MarkerBadge';

const NavigationCartButton = ({
  cartStore,
  configStore,
  className,
  wrapperClassName,
}) => {
  const getPrice = () => {
    return cartStore.cart?.productsTotal?.value || 0;
  };

  const getHidePriceOnMobile = () => getPrice() > 1000;

  const renderPrice = () => {
    return cartStore.cart?.total?.text || '';
  };

  const renderCartText = () => {
    if (!cartStore.hasCart || cartStore.cart.number_of_products === 0) {
      return <FormattedMessage {...globalTranslations.cartEmptySentence} />;
    } else {
      return (
        <span>
          <FormattedMessage
            {...globalTranslations.itemCount}
            values={{
              count: cartStore.cart.number_of_products,
            }}
          />{' '}
          {renderPrice()}
        </span>
      );
    }
  };

  const isLoading = cartStore.state === RequestState.LOADING;

  return (
    <div
      className={classNames(
        'NavigationCart',
        'NavigationCartButton',
        className
      )}
    >
      <div
        className={classNames({
          'NavigationCart__cart-button-wrapper':
            configStore.siteConfig.siteType !==
            SiteType.WEB_STORE_WITH_OFFER_REQUESTS,
          'NavigationCart__combination-button-wrapper':
            configStore.siteConfig.isHybrid,
          wrapperClassName,
        })}
      >
        <Button
          block
          color="primary"
          onClick={() => cartStore.cartModal.toggle(true)}
          disabled={isLoading}
          className="NavigationCart__cart-button"
        >
          <Icon
            name={isLoading ? 'circle-o-notch' : 'shopping-cart'}
            spin={isLoading}
          />
          <span
            className={classNames('NavigationCart__cart-text', {
              'NavigationCart__cart-text--hide-on-mobile':
                getHidePriceOnMobile(),
            })}
          >
            <span className="NavigationCart__cart-text-desktop">
              {renderCartText()}
            </span>
            {cartStore.hasCart && <span className="NavigationCart__cart-text-mobile">
              {renderPrice()}
            </span>}
          </span>
        </Button>
        {cartStore.hasCart && cartStore.cart.number_of_products > 0 && (
          <MarkerBadge className="d-xs-inline d-md-none">
            {cartStore.cart.number_of_products}
          </MarkerBadge>
        )}
      </div>
    </div>
  );
};

NavigationCartButton.propTypes = {
  cartStore: modelOf(CartStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

export default inject(
  'cartStore',
  'configStore'
)(observer(NavigationCartButton));
